module.exports = __webpack_public_path__ + "static/media/graphicdesign.fc139570.png";